import { useState } from "react";

export type UseMachineSelectionOptions = {
  includeRegion?: boolean;
  onMachineChange?: (machineId: string) => void;
  onRegionChange?: (region: string) => void;
};

/**
 * Hook to manage machine and region selection state
 */
export function useMachineSelection(options: UseMachineSelectionOptions = {}) {
  const { includeRegion = false, onMachineChange, onRegionChange } = options;

  const [selectedRegion, setSelectedRegion] = useState<string>("");
  const [selectedMachineId, setSelectedMachineId] = useState<string>("");

  const handleRegionChange = (value: string) => {
    setSelectedRegion(value);
    setSelectedMachineId("");
    onRegionChange?.(value);
  };

  const handleMachineChange = (value: string) => {
    setSelectedMachineId(value);
    onMachineChange?.(value);
  };

  const resetSelection = () => {
    if (includeRegion) {
      setSelectedRegion("");
    }
    setSelectedMachineId("");
  };

  return {
    selectedRegion,
    selectedMachineId,
    handleRegionChange,
    handleMachineChange,
    resetSelection,
  } as const;
}
